import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { courseTwo, kandakeHerbalist, herbalWalkPortrait } from '@/assets/siteMedia'
import { volumes } from '@/data/books'

export const BooksVolumes = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader
        title="Three volumes."
        accent="One complete journey."
        description="Each volume stands alone, yet together they form a complete map of women's health from first period to post-menopause."
      />

      <ol className="mb-14 grid gap-6 lg:grid-cols-3">
        {volumes.map((v, index) => (
          <li key={v.n}>
            <Reveal delay={index * 100} className="h-full">
              <div className="flex h-full flex-col rounded-3xl border border-base-200 bg-white p-7 transition-colors hover:border-green-300">
                <span className="mb-4 block font-display text-sm text-gold-500">{v.n}</span>
                <h3 className="mb-4 font-display text-xl leading-snug text-base-900">{v.title}</h3>
                <p className="flex-1 text-sm leading-6 text-base-600">{v.desc}</p>
                <div className="mt-6 border-t border-base-200 pt-4">
                  <span className="inline-flex items-center gap-2 rounded-full bg-gold-50 px-3 py-1 text-xs font-medium text-base-700">
                    <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-gold-400" />
                    Coming soon
                  </span>
                </div>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>

      <Reveal>
        <div className="grid gap-4 sm:grid-cols-3">
          <SitePhoto src={courseTwo} alt="Kandake sharing women's health knowledge" />
          <SitePhoto src={kandakeHerbalist} alt="Herbal medicine research and preparation" />
          <SitePhoto src={herbalWalkPortrait} alt="Traditional plant knowledge in practice" />
        </div>
      </Reveal>
    </div>
  </section>
)
